export default function ContainerFeatures() {
  const features = [
    {
      icon: 'ri-docker-line',
      title: 'Docker 容器化',
      description: '基于 Docker 技术，一键部署，支持 Kubernetes 编排，轻松实现微服务架构'
    },
    {
      icon: 'ri-api-line',
      title: 'RESTful API',
      description: '标准化的 REST API 接口，支持 JSON 格式数据交互，易于集成和调用'
    },
    {
      icon: 'ri-speed-line',
      title: '高性能处理',
      description: '优化的处理引擎，支持并发请求，毫秒级响应，满足高并发场景需求'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      description: '内置安全机制，支持 HTTPS 加密传输，数据隔离，确保文档处理安全'
    },
    {
      icon: 'ri-scales-3-line',
      title: '弹性扩展',
      description: '支持水平扩展，根据负载自动调整实例数量，保证服务稳定性'
    },
    {
      icon: 'ri-code-box-line',
      title: '多语言支持',
      description: '提供多种编程语言的 SDK，包括 Python、Java、Node.js、PHP 等'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            核心特性
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            现代化的容器技术，为您的 PDF 处理提供强大支持
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
